import { Box, styled } from "@mui/material";

const ContentCardRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== "width" && prop !== "margin",
})(({ theme, width, margin }) => ({
  flex: width ? "0 0 auto" : 1,
  width: width ?? undefined,
  minWidth: 0,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "16px",
  backgroundColor: "#fff",
  boxSizing: "border-box",
  margin: margin ?? undefined,
}));

const ContentCard = ({ children, width, margin, className, sx, ...rest }) => (
  <ContentCardRoot
    width={width}
    margin={margin}
    className={className}
    sx={sx}
    {...rest}
  >
    {children}
  </ContentCardRoot>
);

export default ContentCard;
